import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectTextBottom24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectTextBottom24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 20.25a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 .75.75m2.5-3a.75.75 0 0 1-.75.75H6.25a.75.75 0 0 1 0-1.5h11.5a.75.75 0 0 1 .75.75M18 12.5H6A1.5 1.5 0 0 1 4.5 11V6A1.5 1.5 0 0 1 6 4.5h12A1.5 1.5 0 0 1 19.5 6v5a1.5 1.5 0 0 1-1.5 1.5m3-1.5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectTextBottom24);
